import * as React from 'react';

import { RouteStore } from 'bernie-core';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { PriceBreakDownViewModel } from 'models';

import { PriceBreakDownContent } from './price-breakdown-content';
import { PriceBreakDownDialog } from './price-breakdown-dialog';
import { PriceBreakDownMenu } from './price-breakdown-menu';

export interface ChildActionsOptions {
  trackingRfrr?: string;
  className?: string;
}

export interface PriceBreakDownProps {
  priceBreakDownModel: PriceBreakDownViewModel[];
  routeStore?: RouteStore;
  id?: string;
  roomName?: string;
  layerId: string | number;
  childActions?: (options: ChildActionsOptions) => React.ReactNode;
}

export const PriceBreakDown: React.FunctionComponent<PriceBreakDownProps> = props => {
  const { priceBreakDownModel, id, roomName, layerId, childActions } = props;

  if (!priceBreakDownModel) {
    return null;
  }

  const commonPriceBreakdownProps = {
    priceBreakDownModel,
    id
  };

  const commonPriceBreakDownContentProps = {
    priceBreakDownModel,
    roomName
  };

  const childActionDialog = typeof childActions === 'function' ? childActions({ trackingRfrr: 'PriceDetailDialog' }) : null;
  const childActionMenu =
    typeof childActions === 'function'
      ? childActions({ trackingRfrr: 'PriceDetailMenu', className: 'all-x-padding-four all-t-padding-four' })
      : null;

  return (
    <div className="price-details">
      <Viewport>
        <ViewSmall>
          <PriceBreakDownDialog
            {...commonPriceBreakdownProps}
            layerId={layerId}
            childContent={<PriceBreakDownContent {...commonPriceBreakDownContentProps} view="small" childActions={childActionDialog} />}
          />
        </ViewSmall>
        <ViewMedium>
          <PriceBreakDownMenu
            {...commonPriceBreakdownProps}
            childContent={<PriceBreakDownContent {...commonPriceBreakDownContentProps} childActions={childActionMenu} />}
          />
        </ViewMedium>
      </Viewport>
    </div>
  );
};
